import { SupportedLanguage } from '@foundation/localization';

import { ProcessingKZLocale } from './schemas/ProcessingKZLocale';

export const ProcessingKZSupportedLocale: {
  [key in SupportedLanguage]: ProcessingKZLocale;
} = {
  [SupportedLanguage.Bulgarian]: 'en',
  [SupportedLanguage.Czech]: 'en',
  [SupportedLanguage.ChineseSimplifiedChina]: 'en',
  [SupportedLanguage.ChineseTraditionalHongKong]: 'en',
  [SupportedLanguage.Danish]: 'en',
  [SupportedLanguage.Dutch]: 'en',
  [SupportedLanguage.English]: 'en',
  [SupportedLanguage.Finnish]: 'en',
  [SupportedLanguage.French]: 'en',
  [SupportedLanguage.German]: 'en',
  [SupportedLanguage.Hungarian]: 'en',
  [SupportedLanguage.Indonesian]: 'en',
  [SupportedLanguage.Italian]: 'en',
  [SupportedLanguage.Japanese]: 'en',
  [SupportedLanguage.Korean]: 'en',
  [SupportedLanguage.Norwegian]: 'en',
  [SupportedLanguage.Polish]: 'en',
  [SupportedLanguage.Portuguese]: 'en',
  [SupportedLanguage.Russian]: 'ru',
  [SupportedLanguage.Spanish]: 'en',
  [SupportedLanguage.Swedish]: 'en',
  [SupportedLanguage.Thai]: 'en',
  [SupportedLanguage.Turkish]: 'en',
  [SupportedLanguage.Ukrainian]: 'en',
  [SupportedLanguage.Vietnamese]: 'en',
  [SupportedLanguage.Icelandic]: 'en',
  [SupportedLanguage.Lithuanian]: 'en',
  [SupportedLanguage.Romanian]: 'en',
  [SupportedLanguage.Estonian]: 'en',
  [SupportedLanguage.Malaysian]: 'en',
  [SupportedLanguage.Latvian]: 'en',
  [SupportedLanguage.ChineseTraditionalTaiwan]: 'en',
};
